import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
`

export const Header = styled.button`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  width: 100%;
`

export const StaticHeader = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
  width: 100%;
`

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
  flex: 1;
`

export const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: ${props => props.theme.spacing.sp32};
  gap: ${props => props.theme.spacing.sp4};
  background-color: ${props => props.theme.colors.disabled.surface};
  border-radius: ${props => props.theme.spacing.sp4};
  padding: ${props => props.theme.spacing.sp16};
`

export const DetailItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp4};
`

export const MetaContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`
